/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Toptechpay
 */
export class Toptechpay {
    /**
     *
     * @type {string}
     * @memberof Toptechpay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Toptechpay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Toptechpay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Toptechpay
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Toptechpay
     */
    groupId: string;
    /**
     *
     * @type {boolean}
     * @memberof Toptechpay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Toptechpay
     */
    autoApprove: boolean;
}
